/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_PositionInputs */



/**
* | output |
* | --- |
* | "Position" |
*
* @param {Compare_Event_Groups_Option_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_position = /** @type {((inputs?: Compare_Event_Groups_Option_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição")
	return /** @type {LocalizedString} */ ("Position")
});